module.exports = "/_next/static/images/icon_minus_circle-244b9f758aaca1e7738feba6848cc4c6.svg";